import { render } from "./AiDescriptionInput.vue?vue&type=template&id=2806e6e6&scoped=true"
import script from "./AiDescriptionInput.vue?vue&type=script&lang=js"
export * from "./AiDescriptionInput.vue?vue&type=script&lang=js"

import "./AiDescriptionInput.vue?vue&type=style&index=0&id=2806e6e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2806e6e6"]])

export default __exports__